import { Box, Button, HStack, Stack, useDisclosure } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router";
import { MaterialIcon } from "../../../components/shared/MaterialIcon";
import SearchInput from "../../../components/shared/SearchInput";
import { useAuth } from "../../../providers/AuthProvider";
import { useListRegistries } from "../../../services/api/registries/queries/useListRegistries";
import useReadRegistry from "../../../services/api/registries/queries/useReadRegistry";
import { IRegistry } from "../models/Registry";
import { AddRegistryModal } from "./AddRegistryModal";
import { EditRegistryModal } from "./EditRegistryModal";
import RegistryGrid from "./RegistryGrid";

const Registries = () => {
  const [registrySearch, setRegistrySearch] = React.useState("");
  const [editRegistry, setEditRegistry] = React.useState<IRegistry>();

  const navigate = useNavigate();

  const {
    isOpen: isOpenAddRegistryModal,
    onOpen: onOpenAddRegistryModal,
    onClose: onCloseAddRegistryModal,
  } = useDisclosure();

  const {
    isOpen: isOpenEditRegistryModal,
    onOpen: onOpenEditRegistryModal,
    onClose: onCloseEditRegistryModal,
  } = useDisclosure();

  const { userProfile } = useAuth();

  const { data, isLoading } = useListRegistries();

  const { data: dataRegistry } = useReadRegistry(editRegistry?.id);

  const handleOnCreateRegistry = () => {
    onOpenAddRegistryModal();
  };

  const handleOnEditRegistry = (registry: IRegistry) => {
    setEditRegistry(registry);
    onOpenEditRegistryModal();
  };

  const handleOnViewData = (registry: IRegistry) => {
    if (registry.abbreviation) {
      const open_dashboard_url = `/stats/dashboard?registry=${registry.abbreviation}`;
      window.open(open_dashboard_url, "_blank", "noopener,noreferrer");
    }
  };

  const handleOnClickRegistry = (registry: IRegistry) => {
    navigate(`/app/registries/${registry.id}`);
  };

  return (
    <>
      <Box h="full">
        <Stack spacing={8}>
          <HStack justify={"space-between"}>
            <SearchInput
              search={registrySearch}
              setSearch={setRegistrySearch}
              placeholder="Search registries"
            ></SearchInput>

            {userProfile.is_admin && (
              <Box>
                <Button
                  variant={"outline"}
                  colorScheme={"primary"}
                  onClick={handleOnCreateRegistry}
                  leftIcon={
                    <MaterialIcon
                      name="add"
                      fontSize="1rem"
                      variant="outline"
                    />
                  }
                >
                  Create Registry
                </Button>
              </Box>
            )}
          </HStack>
          <RegistryGrid
            isLoading={isLoading}
            registries={data}
            search={registrySearch}
            setSearch={setRegistrySearch}
            onClickRegistry={handleOnClickRegistry}
            onEditRegistry={handleOnEditRegistry}
            onViewData={handleOnViewData}
          ></RegistryGrid>
        </Stack>
      </Box>
      <AddRegistryModal
        isOpen={isOpenAddRegistryModal}
        onClose={onCloseAddRegistryModal}
      ></AddRegistryModal>
      {dataRegistry && isOpenEditRegistryModal && (
        <EditRegistryModal
          isOpen={isOpenEditRegistryModal}
          onClose={onCloseEditRegistryModal}
          registry={dataRegistry}
        ></EditRegistryModal>
      )}
    </>
  );
};

export default Registries;
